import { render } from "./reportstabset.vue?vue&type=template&id=57865b8f"
import script from "./reportstabset.vue?vue&type=script&lang=js"
export * from "./reportstabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__